var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imgSource)?_c('img',{class:_vm.sizeClass,attrs:{"alt":"make logo","src":_vm.imgSource,"loading":"lazy"}}):_c('div',{staticClass:"tw-size-5"})}
var staticRenderFns = []

export { render, staticRenderFns }